<template>
  <div class="index-brief">
    <div v-if="loading" class="brief-loading">
      <img src="../../assets/images/gif-loading.gif" alt="loading">
    </div>
    <template v-else>
      <div class="index-compare row mb-2 h5 font-weight-bold" v-if="ordinaryDisplay">
		  <div class="col-12 col-md-auto">{{ indexCompare.title }}：</div>
		  <div class="col-12 col-md-auto"><span class="number">{{ indexCompareValueKSep }}</span></div>
      </div>
      <div class="index-compare row mb-2 h5 font-weight-bold" v-if="noTownValue">
		  <div class="col-12 col-md-auto">（{{ location.countyname }}之）{{ indexCompare.title }}：</div>
		  <div class="col-12 col-md-auto"><span class="number">{{ indexCompareValueKSep }}</span></div>
      </div>
      <br/>
      <div class="index-rank row mb-2 h5 font-weight-bold" v-if="hasTownValueAndNotCounty">
		  <div class="col-12 col-md-auto">{{ indexCompare.title }}於縣市排名：</div>
		  <div class="col-12 col-md-auto"><span class="number">{{ townIndexRankInCounty }} / {{ townNumberInCounty }}</span></div>
      </div>
      <div class="index-rank row mb-2 h5 font-weight-bold" v-if="ordinaryDisplay">
		  <div class="col-12 col-md-auto">{{ indexCompare.title }}於全國排名：</div>
		  <div class="col-12 col-md-auto"><span class="number">{{ indexNationalRank }} / {{ totalTownNumbers }}</span></div>
      </div>
      <div class="index-rank row mb-2 h5 font-weight-bold" v-if="noTownValue">
		  <div class="col-12 col-md-auto">（{{ location.countyname }}之）{{ indexCompare.title }}於全國排名：</div>
		  <div class="col-12 col-md-auto"><span class="number">{{ indexNationalRank }} / {{ totalTownNumbers }}</span></div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: ["location", "indexCompare", "countyList", "townList"],
  mounted() {
    this.getBrief();
  },
  data() {
    return {
      loading: true,
      indexCompareValue: null,
	  indexCompareValueKSep: "",
	  indexCompareValueNull: false,
      townIndexRankInCounty: null,
      townNumberInCounty: 0,
      indexNationalRank: 0,
	  totalTownNumbers: 0
    }
  },
  methods: {
    getTownRank() {
      this.axios.post("countyrank", {
        dataset: this.indexCompare.dataset,
        year: "_" + this.indexCompare.year,
        adminscl: "_town",
        column: this.indexCompare.column,
        id: this.location.id
      })
      .then((resp) => {
		if(resp.data[this.indexCompare.column] != null) {
			this.townIndexRankInCounty = resp.data.rank;
		}else{
			this.townIndexRankInCounty = '－';
		}
		this.townNumberInCounty = resp.data.count
      })
      .catch(function (error) {
        console.log(error);
      });
    },
    //getTownNumber() {
    //  let county_id = this.townList.filter( x => x.town_id_n == this.location.id)[0].county_id_n
    //  this.townNumberInCounty = this.townList.filter( x => x.county_id_n == county_id).length
    //},
    getNationalRank() {
      if(this.indexCompare.minscl != 'county') {
		this.axios.post("nationalrank", {
			dataset: this.indexCompare.dataset,
			year: "_" + this.indexCompare.year,
			adminscl: "_" + this.location.type,
			column: this.indexCompare.column,
			id: this.location.id
		})
		.then((resp) => {
			if(resp.data[this.indexCompare.column] != null) {
				this.indexCompareValue = resp.data[this.indexCompare.column];
				this.indexCompareValueKSep = this.KSep(this.indexCompareValue);
				this.indexNationalRank = resp.data.rank;
				//this.totalTownNumbers = resp.data.count;
				if (this.location.type == 'county'){
					this.totalTownNumbers = 22;
				}else{
					this.totalTownNumbers = 368;
				}
				this.indexCompareValueNull = false
				this.loading = false;
			}else{
				this.axios.post("nationalrank", {
					dataset: this.indexCompare.dataset,
					year: "_" + this.indexCompare.year,
					adminscl: "_county",
					column: this.indexCompare.column,
					id: this.location.countyid
				})
				.then((resp) => {
					if(resp.data[this.indexCompare.column] != null) {
						this.indexCompareValue = resp.data[this.indexCompare.column];
						this.indexCompareValueKSep = this.KSep(this.indexCompareValue);
						this.indexNationalRank = resp.data.rank;
					}else{
						this.indexCompareValueKSep = '－';
						this.indexNationalRank = '－'
					}
					//this.totalTownNumbers = resp.data.count;
					this.totalTownNumbers = 22;
					this.loading = false
				})
				.catch(function (error) {
					console.log(error);
				});
				this.indexCompareValueNull = true
				this.loading = false
			}
		})
		.catch(function (error) {
			console.log(error);
		});
	  }else{
		this.axios.post("nationalrank", {
			dataset: this.indexCompare.dataset,
			year: "_" + this.indexCompare.year,
			adminscl: "_county",
			column: this.indexCompare.column,
			id: this.location.countyid
		})
		.then((resp) => {
			//console.log(this.location)
			//console.log(this.indexCompare);
			if(resp.data[this.indexCompare.column] != null) {
				this.indexCompareValue = resp.data[this.indexCompare.column];
				this.indexCompareValueKSep = this.KSep(this.indexCompareValue);
				this.indexNationalRank = resp.data.rank;
				this.indexCompareValueNull = false
			}else{
				this.indexCompareValueKSep = '－';
				this.indexNationalRank = '－'
				this.indexCompareValueNull = true
			}
			//this.totalTownNumbers = resp.data.count,
			this.totalTownNumbers = 22,
			this.loading = false;
			//console.log(resp.data)
		})
		.catch(function (error) {
			console.log(error);
		});
	  }
    },
    getBrief() {
      if(this.indexCompare.minscl != 'county') {
        this.getTownRank()
        //this.getTownNumber()
      }
	  this.getNationalRank();
	  $(window).scrollTop(0);
    },
	KSep(val){
		if (val != null){
			return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		}else{
			return "－"
		}
	}
  },
  computed: {
	ordinaryDisplay: function () {
		return (this.indexCompare.minscl != 'county' && !this.indexCompareValueNull) || this.location.type == 'county';
	},
	noTownValue: function () {
		return (this.indexCompare.minscl == 'county' && this.location.type != 'county') || this.indexCompareValueNull;
	},
	hasTownValueAndNotCounty: function () {
		return this.indexCompare.minscl != 'county' && this.location.type != 'county' && !this.indexCompareValueNull;
	}
  },
  watch: {
    location: {
      handler: function() {
        this.getBrief()
      },
      deep: true
    }
  }

}
</script>

<style lang="scss" scoped>
@import "../../css/custom_var";
@import "../../css/custom_mixin";

.brief-loading {
  img {
    width: 100px;
    height: 100px;
  }
}

.index-brief {
  margin-top: 8px;
  margin-bottom: 20px;
  * {
    line-height: 1.3;
  }
  .number {
    // margin-left: 20px;
    // font-size: 1.25rem;
    color: $ts-orange;
  }
}

</style>
